import VUE_APP_API_COUPON_URL from './getapi/coupon'
let apiURL = '';

if (process.env.NODE_ENV === "development") {
    // alert("开发环境");
    apiURL = 'https://kane.haiweikexin.com/getcoupon'
}else {
    // alert("生产环境");
    apiURL = VUE_APP_API_COUPON_URL
}

export default apiURL